<div class="container">
    <h1 class="page-title"
    [helpCenterButton]="viewPermissionCode" [lang]="currentLang"
    [helpCenterDownloadButton]="viewPermissionCode" [position]="'inline'" [lang]="currentLang">
    <span class="icon"><i class="fas fa-map-pin"></i></span>{{ 'AddressMaintain.Header' | translate}}
  </h1>
  <p-card>
    <p-accordion>
      <p-accordionTab header="{{ 'Common.Form.Header' | translate}}" [(selected)]="isSearchFormOpen">
        <form [formGroup]="searchForm" (ngSubmit)="searchBtnClick()">
          <div class="grid formgrid p-fluid">
            <div class="col-3 field">
              <label>{{ 'AddressMaintain.Form.ConsigneeKey' | translate}}</label>
              <laas-customer-dropdown
                formControlName="consigneeKey"
                [isSingle]="true"
                [showClear]="true"
                [divClass]="'field'"
              ></laas-customer-dropdown>
            </div>
            <laas-location-cascade-dropdown
              formControlName="searchLocation"
              [showCountry]="true"
              [showCity]="true"
              [showArea]="false"
              [showExpressArea]="false"
              [showDistrict]="true"
              [useMultiSelectForCountry]="false"
              [useMultiSelectForCity]="false"
              [useMultiSelectForArea]="false"
              [useMultiSelectForExpressArea]="false"
              [useMultiSelectForDistrict]="false"
              countryLabel="{{ 'AddressMaintain.Form.Country' | translate }}"
              cityLabel="{{ 'AddressMaintain.Form.City' | translate }}"
              districtLabel="{{ 'AddressMaintain.Form.AssignmentDistrict' | translate }}"
              countryPlaceholder="{{ 'Common.DropDown.Select' | translate }}"
              cityPlaceholder="{{ 'Common.DropDown.Select' | translate }}"
              districtPlaceholder="{{ 'Common.DropDown.Select' | translate }}"
              [allowAllOption]="false"
              [showClear]="true"
              [enableFilter]="true"
              [cssClasses]="'col-3 field'"
              (countryOptionsReady)="onCountryOptionsReady($event)"
              (cityOptionsReady)="onCityOptionsReady($event)"
              (districtOptionsReady)="onDistrictOptionsReady($event)"
              (countryChange)="countryChange($event)"
              (cityChange)="cityChange($event)">
            </laas-location-cascade-dropdown>
            <div class="col-6 field">
              <label>{{ 'AddressMaintain.Form.DeliveryToLocalName' | translate}}</label>
              <input type="text" pInputText formControlName="deliveryLocalName" />
            </div>
            <div class="col-6 field">
              <label>{{ 'AddressMaintain.Form.DeliveryToEngName' | translate}}</label>
              <input type="text" pInputText formControlName="deliveryEngName" />
            </div>
            <div class="col-6 field">
              <label>{{ 'AddressMaintain.Form.Airport' | translate}}</label>
              <p-dropdown
              [filter]="true"
              placeholder="{{ 'Common.DropDown.Select' | translate}}"
              filterBy="label"
              [options]="airPortOptions"
              [showClear]="true"
              appendTo="body"
              formControlName="airport"
              (keydown)="onDropdownKeydown($event)"
            ></p-dropdown>
            </div>
            <div class="col-6 field">
              <label>{{ 'AddressMaintain.MainTable.Column.GroupId' | translate}}</label>
              <input type="text" pInputText formControlName="groupId" />
            </div>
            <div class="col-12 field">
              <label>{{ 'AddressMaintain.Form.LocalAddress' | translate}}</label>
              <input type="text" pInputText formControlName="localAddress" />
            </div>
            <div class="col-12 field">
              <label>{{ 'AddressMaintain.Form.EngAddress' | translate}}</label>
              <input type="text" pInputText formControlName="engAddress" />
            </div>
          </div>
          <div>
            <button pButton label="{{ 'Common.Button.Search' | translate }}" type="submit"></button>
            <button
              pButton
              label="{{ 'Common.Button.Reset' | translate }}"
              type="reset"
              class="p-button-secondary ml-2"
            ></button>
          </div>
        </form>
      </p-accordionTab>
    </p-accordion>
    <p-table
      #addrTable
      laasDataTableSetting
      [tableKey]="headerPreferenceKey"
      [defaultColumns]="tableColumns"
      [value]="tableValue"
      [scrollable]="true"
      scrollHeight="500px"
      [reorderableColumns]="true"
      [resizableColumns]="true"
      [totalRecords]="this.pageInfo.totalRecords"
      (onPage)="this.tablePageChange($event)"
      (onSort)="this.tableSort($event)"
      (setPageSize)="this.setPageSize($event)"
      [rowsPerPageOptions]="[5, 10, 20]"
      [showCurrentPageReport]="true"
      [paginator]="true"
      [rows]="5"
      [loading]="isHeaderLoading"
      [lazy]="true"
      currentPageReportTemplate="{{ 'Common.Table.PageSummary' | translate }}"
      selectionMode="single"
      [selection]="selectedRow"
      class="edittable"
      dataKey="rowId"
      editMode="row"
      styleClass="datatable-gridlines datatable-striped mt-2 white-space: nowrap;"
    >
      <ng-template pTemplate="caption">
        <laas-table-column-toggle
          [optionsColumn]="tableColumns"
          [dataTable]="addrTable">
        </laas-table-column-toggle>
        <button
          pButton
          type="button"
          label="{{ 'Common.Button.Add' | translate}}"
          icon="fas fa-plus"
          [disabled]="!editMode"
          class="p-button-success p-button-raised ml-2"
          (click)="createNewRow()"
        ></button>
        <button
          pButton
          type="button"
          label="{{ 'Common.Button.Delete' | translate}}"
          icon="fas fa-trash-alt"
          [disabled]="!editMode"
          (click)="deleteSelectedRow()"
          class="p-button-danger p-button-raised ml-2"
        ></button>
        <button
          pButton
          type="button"
          label="{{ 'Common.Button.Save' | translate}}"
          icon="fas fa-save"
          [disabled]="!editMode"
          (click)="saveBtnClick()"
          class="p-button-raised ml-2"
        ></button>
        <button
          pButton
          type="button"
          label="{{ 'AddressMaintain.Button.Rollback' | translate }}"
          icon="fas fa-sync-alt"
          [disabled]="!editMode"
          (click)="resetTableValue()"
          class="p-button-secondary p-button-raised ml-2"
        ></button>
        <laas-permission-button
          permissionCode="EditAddressMaintainSetting"
          type="button"
          label="{{ 'AddressMaintain.Button.ViewOrEdit' | translate }}"
          icon="fas fa-pen"
          [disabled]="!this.canEditTable"
          (onClick)="switchEditMode()"
          [class]="'p-button-warning p-button-raised ml-2'"
          style="color: white"
        ></laas-permission-button>
      </ng-template>

      <ng-template pTemplate="colgroup" let-columns>
        <colgroup>
          <col *ngFor="let col of columns" [style]="{ width: col.width + 'px' }">
        </colgroup>
      </ng-template>

      <ng-template pTemplate="header" let-columns>
        <tr>
          <th
            [pSortableColumn]="col.field"
            [pSortableColumnDisabled]="!col.sort"
            *ngFor="let col of columns"
            pResizableColumn
            pReorderableColumn
            [attr.field]="col.field">
            {{ col.header | translate }}
            <p-sortIcon [field]="col.field"></p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template
        pTemplate="body"
        let-rowData
        let-columns="columns"
      >
        <tr [pSelectableRow]="rowData" [pEditableRow]="rowData" (click)="onRowSelect(rowData)">
          <td *ngFor="let col of columns">
            <ng-container [ngSwitch]="col.field">
              <p-cellEditor *ngSwitchCase="'groupId'" class="p-fluid">
                <ng-template pTemplate="input">
                  <div class="overflow-text">{{ rowData[col.field] | replaceNullWith:'-'}}</div>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">{{ rowData[col.field] | replaceNullWith:'-'}}</div>
                </ng-template>
              </p-cellEditor>
              <p-cellEditor *ngSwitchCase="'consigneeKey'">
                <ng-template pTemplate="input" >
                  <div *ngIf="selectedRow.groupId then oldRow else newRow"></div>
                  <ng-template #newRow>
                    <laas-customer-dropdown
                      [isSingle]="true"
                      (keydown)="onDropdownKeydown($event)"
                      [(ngModel)]="rowData[col.field]"
                      [showClear]="true"
                      [divClass]="'p-fluid'"
                    ></laas-customer-dropdown>
                  </ng-template>
                  <ng-template #oldRow>
                    <div class="overflow-text">{{ rowData[col.field] | optionsMapping: this.customerOptions | replaceNullWith:'-'}}</div>
                  </ng-template>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">{{ rowData[col.field] | optionsMapping: this.customerOptions | replaceNullWith:'-'}}</div>
                </ng-template>
              </p-cellEditor>

              <p-cellEditor *ngSwitchCase="'country'">
                <ng-template pTemplate="input">
                  <p-dropdown
                    [filter]="true"
                    placeholder="{{ 'Common.DropDown.Select' | translate}}"
                    [options]="countryOptions"
                    appendTo="body"
                    [showClear]="true"
                    (onChange)="tableCountryChange(rowData)"
                    [(ngModel)]="rowData[col.field]"
                    class="p-fluid"
                    (keydown)="onDropdownKeydown($event)"
                  >
                  </p-dropdown>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">{{ rowData[col.field] | optionsMapping: this.allCountryOptions | replaceNullWith:'-'}}</div>
                </ng-template>
              </p-cellEditor>

              <p-cellEditor *ngSwitchCase="'city'">
                <ng-template pTemplate="input">
                  <p-dropdown
                    [filter]="true"
                    placeholder="{{ 'Common.DropDown.Select' | translate}}"
                    appendTo="body"
                    [options]="tableCityOptions"
                    [showClear]="true"
                    (onChange)="tableCityChange(rowData)"
                    [(ngModel)]="rowData[col.field]"
                    class="p-fluid"
                    (keydown)="onDropdownKeydown($event)"
                  ></p-dropdown>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">{{ rowData[col.field] | optionsMapping: this.cityAllOptions | replaceNullWith:'-'}}</div>
                </ng-template>
              </p-cellEditor>

              <p-cellEditor *ngSwitchCase="'assignmentDistrictId'" class="p-fluid">
                  <ng-template pTemplate="input">
                    <p-dropdown
                      [filter]="true"
                      placeholder="{{ 'Common.DropDown.Select' | translate}}"
                      appendTo="body"
                      [options]="tableDistrictOptions"
                      [showClear]="true"
                      [(ngModel)]="rowData[col.field]"
                      (keydown)="onDropdownKeydown($event)"
                    ></p-dropdown>
                  </ng-template>
                  <ng-template pTemplate="output">
                    <div class=overflow-text>{{ rowData[col.field] | optionsMapping: this.districtAllOptions | replaceNullWith:'-'}}</div>
                  </ng-template>
              </p-cellEditor>

              <p-cellEditor *ngSwitchCase="'localAddress'" class="p-fluid">
                <ng-template pTemplate="input" >
                  <input
                    pInputText
                    type="text"
                    required
                    [(ngModel)]="rowData[col.field]"

                    #val ="ngModel"
                  />
                  <small *ngIf="!rowData.localAddress && !rowData.engAddress" class="alert">
                    <div class="p-invalid">
                      localAddress is required
                    </div>
                  </small>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">{{ rowData[col.field] | replaceNullWith:'-'}}</div>
                </ng-template>
              </p-cellEditor>

              <p-cellEditor *ngSwitchCase="'engAddress'" class="p-fluid">
                <ng-template pTemplate="input">
                  <laas-text-area-set
                  [row]="1"
                  [maxlength]="135"
                  [(ngModel)]="rowData[col.field]"
                  required
                  class="p-fluid"
                  #val ="ngModel">
                </laas-text-area-set>
                  <small *ngIf="!rowData.localAddress && !rowData.engAddress" class="alert">
                    <div class="p-invalid">
                      engAddress is required
                    </div>
                  </small>
                  <small *ngIf="!dplChecked" class="alert">
                    <div class="p-invalid">
                      dplcheck is fail.
                    </div>
                  </small>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">{{ rowData[col.field] | replaceNullWith:'-'}}</div>
                </ng-template>
              </p-cellEditor>

              <p-cellEditor *ngSwitchCase="'deliveryToEngName'" class="p-fluid">
                <ng-template pTemplate="input">
                  <laas-text-area-set
                    [row]="1"
                    [maxlength]="60"
                    [(ngModel)]="rowData[col.field]"
                    required
                    class="p-fluid">
                  </laas-text-area-set>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">{{ rowData[col.field] | replaceNullWith:'-'}}</div>
                </ng-template>
              </p-cellEditor>

              <p-cellEditor *ngSwitchCase="'airport'" class="p-fluid">
                <ng-template pTemplate="input">
                  <p-dropdown
                    [filter]="true"
                    placeholder="{{ 'Common.DropDown.Select' | translate}}"
                    appendTo="body"
                    [options]="tableAirportOptions"
                    [showClear]="true"
                    [(ngModel)]="rowData[col.field]"
                    class="p-fluid"
                    (keydown)="onDropdownKeydown($event)"
                  ></p-dropdown>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">{{ rowData[col.field] | optionsMapping: this.airPortAllOptions | replaceNullWith:'-'}}</div>
                </ng-template>
              </p-cellEditor>

              <p-cellEditor *ngSwitchCase="'createUser'" class="p-fluid">
                <ng-template pTemplate="input">
                  <div class="overflow-text">{{ rowData[col.field] | replaceNullWith:'-'}}</div>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">{{ rowData[col.field] | replaceNullWith:'-'}}</div>
                </ng-template>
              </p-cellEditor>

              <p-cellEditor *ngSwitchCase="'updateUser'" class="p-fluid">
                <ng-template pTemplate="input">
                  <div class="overflow-text">{{ rowData[col.field] | replaceNullWith:'-'}}</div>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">{{ rowData[col.field] | replaceNullWith:'-'}}</div>
                </ng-template>
              </p-cellEditor>

              <p-cellEditor *ngSwitchCase="'createDt'" class="p-fluid">
                <ng-template pTemplate="input">
                  <div class="overflow-text">{{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-'}}</div>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">{{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-'}}</div>
                </ng-template>
              </p-cellEditor>

              <p-cellEditor *ngSwitchCase="'updateDt'" class="p-fluid">
                <ng-template pTemplate="input">
                  <div class="overflow-text">{{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-'}}</div>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">{{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-'}}</div>
                </ng-template>
              </p-cellEditor>

              <p-cellEditor *ngSwitchDefault class="p-fluid">
                <ng-template pTemplate="input">
                  <input
                    pInputText
                    type="text"
                    [(ngModel)]="rowData[col.field]"
                    class="p-fluid"
                  />
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">{{ rowData[col.field] | replaceNullWith:'-'}}</div>
                </ng-template>
              </p-cellEditor>
            </ng-container>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="tableColumns.length + 1">
            {{ "Common.Table.NoData" | translate }}
          </td>
        </tr>
      </ng-template>
    </p-table>

    <laas-data-table
      *ngIf="selectedRow"
      [(selectedRows)]="selectedDetailRows"
      [lazy]="true"
      [selectable]="true"
      [dataKey]="'seqNo'"
      [rows]="5"
      [expandable]="false"
      [tableKey]="detailPreferenceKey"
      [value]="tableDetailValue"
      [defaultColumns]="tableDetailColumns"
      [totalRecords]="this.detailPageInfo.totalRecords"
      (tableOnPage)="detailTablePageChange($event)"
      [loading] ="isdetailLoading"
    >

      <ng-template pTemplate="caption">
        <div class="col">
          <button
            pButton
            pRipple
            type="button"
            label="{{ 'AddressMaintain.Button.Import' | translate }}"
            class="p-button-raised ml-2"
            (click)="this.openImportDialog()"
            [disabled]="!(selectedRow.groupId && this.canEditTable)">
          </button>
          <button
            pButton
            pRipple
            icon="pi pi-trash"
            class="p-button-danger ml-2"
            (click)="deleteDetailAddress()"
            [disabled]="!(selectedDetailRows.length > 0 && canEditTable)">
          </button>
        </div>
      </ng-template>

      <ng-template pTemplate="body" let-rowData let-columns="columns">
        <td *ngFor="let col of columns">
          <ng-container [ngSwitch]="col.field">
            <ng-container *ngSwitchDefault>
              <div [ngSwitch]="col.dataType">
                  <ng-container *ngSwitchCase="'date'">
                    <div class="overflow-text">
                      {{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss' | replaceNullWith:'-' }}
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchDefault>
                    <div class="overflow-text">
                      {{ rowData[col.field] | replaceNullWith:'-'}}
                    </div>
                  </ng-container>
              </div>
            </ng-container>
          </ng-container>
        </td>
      </ng-template>
    </laas-data-table>
  </p-card>

  <p-dialog *ngIf="isImportDialogOpen" header="{{ 'AddressMaintain.Button.Import' | translate }}" appendTo="body" [(visible)]="isImportDialogOpen" [modal]="true" [draggable]="false"
  [resizable]="false" [style]="{ width: '80%' }">
    <laas-data-table
      [tableKey]="importPreferenceKey"
      [selectable]="true"
      [(selectedRows)]="selectedImportRows"
      [value]="importAddressValue"
      [dataKey]="'seqNo'"
      [defaultColumns]="importAddressColumns"
      [totalRecords]="this.importPageInfo.totalRecords"
      [loading]="isImportLoading"
      [lazy]="true"
      (tableOnPage)="importTablePageChange($event)"
      (tableOnSort)="importTableSort($event)">

        <ng-template
          pTemplate="body"
          let-rowData
          let-columns="columns"
          >
            <td *ngFor="let col of columns">
              <div>
                {{ rowData[col.field] | replaceNullWith:'-'}}
            </div>
            </td>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="importAddressColumns.length + 1">{{ 'Common.Table.NoData' | translate}}</td>
        </tr>
      </ng-template>
    </laas-data-table>
    <div class="grid mt-2">
      <div class="col text-center">
        <button pRipple pButton label="{{ 'AddressMaintain.Button.Import' | translate }}" (click)="importBtnClick()"></button>
      </div>
    </div>
  </p-dialog>
</div>
<help-dock
  [permissionCode]="viewPermissionCode"
  [lang]="currentLang">
</help-dock>
